import { encodeFunctionData, type Hex } from 'viem';
import { AbiHub } from '$lib/constants/abis';
import { config } from '$lib/constants/circlesV2Config';
import type { Address } from '$types/address';
import { sendUserOperation } from '$services/cometh/sendUserOperation';

export const signupPerson = async (walletAddress: Address): Promise<Hex> => {
  const signupCallData = encodeFunctionData({
    abi: AbiHub,
    functionName: 'signup',
    args: [],
  });

  const signupTransactionData = {
    to: config.v1HubAddress as Address,
    value: BigInt(0),
    data: signupCallData as Hex,
  };

  return await sendUserOperation({ calls: [signupTransactionData], address: walletAddress });
};
